import { memo } from 'react';

import { type WorkspaceAgentIconComponent } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/types';

export type WorkspaceAgentNextActionButtonProps = {
  icon: WorkspaceAgentIconComponent;
  label: string;
  onSelect: () => void;
  testId: string;
};

export const WorkspaceAgentNextActionButton = memo(
  ({ icon: Icon, label, onSelect, testId }: WorkspaceAgentNextActionButtonProps) => (
    <button
      className="inline-flex max-w-full items-center gap-1 rounded-full border ads:border-default border-gray-4 ads:bg-base bg-gray-1 py-1 pr-2.5 pl-1.5 text-left transition-colors focus-visible:outline-none ads:focus-visible:ring-focus focus-visible:ring-2 focus-visible:ring-altitude-8 enabled:active:ads:border-ads-gray-5 enabled:active:border-gray-5 enabled:active:ads:bg-hover-subtle enabled:active:bg-gray-2 enabled:hover:ads:border-ads-gray-5 enabled:hover:border-gray-5 enabled:hover:ads:bg-hover-subtle enabled:hover:bg-gray-2 disabled:cursor-not-allowed disabled:opacity-45"
      data-testid={testId}
      onClick={onSelect}
      type="button"
    >
      <span className="flex shrink-0 items-center justify-center ads:text-icon-subtle text-gray-9">
        <Icon size="xs" />
      </span>
      <span className="min-w-0 truncate font-medium ads:text-primary text-12 text-gray-12">{label}</span>
    </button>
  ),
);

WorkspaceAgentNextActionButton.displayName = 'WorkspaceAgentNextActionButton';
